export const appName: string = "Finding Floridians";
export const appTitle: string = `Your Gateway to Finding a Home in the Sunshine State`;
export const metaDescription: string = `Discover your dream home in Florida with Finding Floridians. Explore properties for sale, watch video tours, and use our AI-driven search to find the perfect match based on your lifestyle and preferences.`;
export const metaKeywords: string = `Florida real estate, Florida homes for sale, property search, video tours, AI home matching, Tampa Bay real estate, buy home in Florida, Florida property listings, move to Florida, Florida neighborhoods`;

export const siteAuthor = `Holoforge LLC`;
export const siteUrl = `https://www.findingfloridians.com`;
export const twitterHandle = `@findingfloridians`;
